import Link from 'next/link'
import React from 'react'
import { useAppContext } from '../../../context/siteMapContext'
import { IArticleHead } from '../../../interfaces/article'
import { urlObjectFactoryForPagesWithSlug } from '../../../utils/webmenus'
import PageTitle from '../../pageTitle.component'
import LightBackground from '../lightBackground.component'

interface IAnnouncementItemProps {
  title: string
  date: string
  urlObject: {
    pathname: string
    query: {
      webmenuId: string
      contentId: string
    }
  }
  asPath: string
}

const AnnouncementItem: React.FC<IAnnouncementItemProps> = ({
  title,
  date,
  urlObject,
  asPath,
}) => {
  return (
    <Link href={urlObject} as={asPath}>
      <a className='flex flex-col lg:flex-row flex-nowrap items-start 2xl:gap-desktop text-home-announcements font-montserrat'>
        <span className='w-full lg:w-1/6'>
          {date.substring(0, date.indexOf(' '))}
        </span>
        <span className='w-full lg:w-5/6'>{title}</span>
      </a>
    </Link>
  )
}

interface IAnnouncementProps {
  announcements: IArticleHead[]
}

const Announcements: React.FC<IAnnouncementProps> = ({ announcements }) => {
  const { webmenus } = useAppContext()

  const createItem = (item: IArticleHead) => {
    const { title, date, heading } = item
    const webmenu = webmenus[heading]
    const { urlObject, asPath } = urlObjectFactoryForPagesWithSlug(
      '/article',
      item,
      webmenu
    )

    return (
      <AnnouncementItem
        key={asPath}
        title={title}
        date={date}
        urlObject={urlObject}
        asPath={asPath}
      />
    )
  }

  return <>
    {!!announcements?.length && <section className='relative mx-page-side-negative-margin w-[calc(100%+44px)] grid grid-cols-4 2xl:grid-cols-12 py-16 pb-[72px] 2xl:pb-16 auto-rows-min px-[22px]'>
      <LightBackground />
      <div className='z-1 col-start-1 2xl:col-start-3 col-span-2'>
        <PageTitle title='Közlemények' />
      </div>
      <div className='z-1 col-start-1 col-span-4 2xl:col-start-4 2xl:col-span-6 pt-8 flex flex-col gap-8'>
        {announcements.sort((a, b) => a.date.localeCompare(b.date)).slice(0, 8).map(createItem)}
      </div>
    </section>}
  </>
}

export default Announcements
